import { render, staticRenderFns } from "./EditSimpleOption.vue?vue&type=template&id=770d60c6"
import script from "./EditSimpleOption.vue?vue&type=script&lang=ts"
export * from "./EditSimpleOption.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports